(function (scope) {
	'use strict';

	var Copyright = function (options) {
		if (options !== undefined) {
			for (var property in options) {
				if ({}.hasOwnProperty.call(options, property)) {
					this[property] = options[property];
				}
			}
		}

		this.initialize();
	};

	Copyright.prototype.initialize = function () {
    var person, i, n;
    var peopleString = '';
    if (!this.list) {
      for (i = 0, n = this.people.length; i < n; i++) {
        person = this.people[i];
        peopleString += person.name + ' / ';
      }
    }

		if (window.navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
			var args = [
        '\n%c' + this.project + '%cWRONG / ' + peopleString + this.year + '\n',
				'background-color:' + this.colors[0] + '; padding:0 1em; color:white; line-height:2.5em;',
        'background-color:' + this.colors[1] + '; padding:0 1em; color:white; line-height:2.5em;'
			];

      if (this.people) {
        if (this.list) {
          args.push('\n');

          for (i = 0, n = this.people.length; i < n; i++) {
            person = this.people[i];
            args.push('⤷ ' + person.name + (person.did ? ' ' + person.did : '') + ' \n\n');
          }
        } else {

        }
      }

			window.console.log.apply(console, args);
		} else if (window.console) {
			window.console.log('✰ ' + this.project + ' ✰ – WRONG / ' + peopleString + this.year);

			if (this.people) {
        if (this.list) {
          for (i = 0, n = this.people.length; i < n; i++) {
            person = this.people[i];
            console.log('⤷ ' + person.name + (person.did ? ' ' + person.did : ''));
          }
        }
      }
		}
	};

	scope.Copyright = Copyright;
})(window.Roots || (window.Roots = {}));
